/**
 * @generated SignedSource<<251ec71121ad984cec3905f434eecbf2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type displayStoryCardCarouselWidgetQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"helpersStyleArticleListQuery">;
  readonly " $fragmentType": "displayStoryCardCarouselWidgetQuery";
};
export type displayStoryCardCarouselWidgetQuery$key = {
  readonly " $data"?: displayStoryCardCarouselWidgetQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"displayStoryCardCarouselWidgetQuery">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "displayStoryCardCarouselWidgetQuery"
};

(node as any).hash = "e83781bdd44837d12f25bbf33403bbec";

export default node;
